import "./Btn.scss";
import { motion } from "framer-motion";
const Btn = ({ theme, title, type, onClick, delay, icon }) => {
  return (
    <motion.button
      initial={{ translateY: 32, opacity: 0 }}
      whileInView={{ translateY: 0, opacity: 1 }}
      transition={{
        duration: 0.6,
        ease: "easeInOut",
        delay: delay ? delay : 0,
      }}
      viewport={{ once: true }}
      type={type ? type : "button"}
      className={`main_btn ${theme}`}
      onClick={onClick}
    >
      {icon && icon}
      <p className="t_14">{title}</p>
    </motion.button>
  );
};

export default Btn;
